import { createFileRoute } from "@tanstack/react-router";
import { AsystentStatsPage } from "@/features/asystent/asystent-stats-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/asystent-statystyki-aptek")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.analityka.asystent-statystyki-aptek",
			location.pathname,
		);
	},
	component: () => <AsystentStatsPage />,
});
